module.exports = {
	"about": "apropos",
	"access": "acces",
	"auction": "encan",
	"auctioneer": "encanteur",
	"auctions": "encans",
	"bids": "offres",
	"billing": "facturation",
	"buying": "acheter",
	"catalog": "catalogue",
	"category": "categorie",
	"claim": "reclamer",
	"confirmemail": "confirmeremail",
	"contact": "coordonnee",
	"control": "controle",
	"country": "pays",
	"create": "creer",
	"dashboard": "tableaudebord",
	"directory": "annuaire",
	"emails": "emails",
	"export": "exporter",
	"features": "caracteristiques",
	"forgotpw": "oublierpw",
	"help": "aide",
	"history": "historique",
	"increments": "augmenter",
	"info": "info",
	"invoice": "facture",
	"invoices": "factures",
	"live": "temps-reel",
	"login": "connexion",
	"logo": "logo",
	"logout": "deconnexion",
	"lot": "lot",
	"management": "gestion",
	"methods": "moyens",
	"monitor": "moniteur",
	"payment": "paiement",
	"permissions": "permissions",
	"phone": "telephone",
	"picture": "photo",
	"press": "presse",
	"pricing": "prix",
	"privacy": "confidentialite",
	"profile": "profil",
	"report": "rapport",
	"resetpw": "reinitialiserpw",
	"search": "rechercher",
	"security": "securite",
	"seller": "vendeur",
	"selleraccount": "comptevendeur",
	"selleraccounts": "comptesvendeur",
	"selling": "vente",
	"settings": "parametres",
	"signup": "inscription",
	"soon": "bientot",
	"staff": "employe",
	"staffaccess": "accesemploye",
	"staffinvite": "invitationemploye",
	"subscription": "abonnement",
	"terminology": "terminologie",
	"terms": "termes",
	"userlist": "listeutilisateur",
	"userlists": "listutilisateurs",
	"userlistrequests": "requetesadhesionliste",
	"usermodel": "modeleutilisateur",
	"users": "utilisateurs"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/routes.json5
// module id = 2009
// module chunks = 6